// ==================================================
//  変数定義
// ==================================================
let vwOld = window.innerWidth;
let vw = window.innerWidth;
const breakpointSP = 767;

// ==================================================
//  Function: モバイル判定
// ==================================================
const isMobile = (vw) => {
  if (breakpointSP >= vw) {
    return true;
  } else {
    return false;
  }
};

document.addEventListener("DOMContentLoaded", function () {
  // ==================================================
  //  ダブルタップによるズーム無効
  // ==================================================
  document.addEventListener(
    "dblclick",
    function (e) {
      e.preventDefault();
    },
    { passive: false }
  );

  // ==================================================
  //  Header Menu SP
  // ==================================================
  const menuButtonClick = function () {
    this.classList.toggle("header_menuButton-active");
    header_menu.classList.toggle("header_navigation-active");
  };

  const header_menu = document.getElementById("header_menu");
  document.getElementById("header_menuButton").addEventListener("click", menuButtonClick, false);
});

// ==================================================
//  Function: main に min-height を設定
// ==================================================
const mainHeightSet = () => {
  const vh = window.innerHeight;
  document.querySelector("main").style.minHeight = vh + "px";
};

// ==================================================
//  Event: HTML文書の読み込みと解析の完了
// ==================================================
document.addEventListener("DOMContentLoaded", (event) => {
  // モバイル判定
  if (isMobile(vw)) {
    // #mainvisual に max-height を設定
    mainHeightSet();
  }
});

// ==================================================
//  Event: ウィンドウサイズが変更された
// ==================================================
window.addEventListener("resize", (event) => {
  vw = window.innerWidth;
  if (vwOld !== vw) {
    // モバイル判定
    if (!isMobile(vw)) {
      // #mainvisual の max-height を削除
      document.querySelector("main").style.removeProperty("min-height");
    } else {
      // #mainvisual に max-height を設定
      mainHeightSet();
    }
    vwOld = vw;
  }
});
